export const REMOVE_LIST_COMPLAIN = 'REMOVE_LIST_COMPLAIN' as const
export const removeListComplainAction = () => ({
  type: REMOVE_LIST_COMPLAIN,
})
export type ComplaintsStreamTypes = ReturnType<typeof removeListComplainAction>
